import { DocumentSubCategoryFacade } from './../../../../../epims-references/src/lib/states/+document-sub-category/document-sub-category.facade';
import { CurrencyFacade } from './../../../../../epims-references/src/lib/states/+currency/currency.facade';
import { DocumentCategoryFacade } from './../../../../../epims-references/src/lib/states/+document-category/document-category.facade';
import { OilFieldFacade } from './../../../../../epims-references/src/lib/states/+oil-field/oil-field.facade';
import { OilBlockFacade } from './../../../../../epims-references/src/lib/states/+oil-block/oil-block.facade';
import { CommunityFacade } from './../../../../../epims-references/src/lib/states/+community/community.facade';
import { ClusterCommunityFacade } from './../../../../../epims-references/src/lib/states/+cluster-community/cluster-community.facade';
import { ClusterFacade } from './../../../../../epims-references/src/lib/states/+cluster/cluster.facade';
import { ProjectCategoryFacade } from './../../../../../epims-references/src/lib/states/+project-category/project-category.facade';
import { ProjectTypeFacade } from './../../../../../epims-references/src/lib/states/+project-type/project-type.facade';
import { LgaFacade } from './../../../../../epims-references/src/lib/states/+lga/lga.facade';
import { StateFacade } from './../../../../../epims-references/src/lib/states/+state/state.facade';
import { CountryFacade } from './../../../../../epims-references/src/lib/states/+country/country.facade';
import { Component, OnInit } from '@angular/core';
import {
  ProjectDto,
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  CommunityDto,
  OilBlockDto,
  OilFieldDto,
  CurrencyDto,
  GMOUDto,
  DocumentSubCategoryDto,
  DocumentCategoryDto,
  ProjectPaymentDto,
  ProjectStakeholderDto,
  ProjectClusterDto,
  ProjectDocumentDto,
  EpimsBankDetailDto,
  EpimsBankDto,
} from '@cradua/data';
import { Observable, Subscription } from 'rxjs';
import { ProjectManagementFacade } from '../../states/+project-management/project-management.facade';
import { GmouFacade } from '../../states/+gmou/gmou.facade';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { ProjectActivityFacade } from '../../states/+project-activity/project-activity.facade';
import { ProjectPaymentFacade } from '../../states/+project-payment/project-payment.facade';
import { ProjectDocumentFacade } from '../../states/+project-document/project-document.facade';
import { ProjectStakeholderFacade } from '../../states/+project-stakeholder/project-stakeholder.facade';
import { ProjectClusterFacade } from '../../states/+project-cluster/project-cluster.facade';
import { EpimsBankDetailFacade } from './../../../../../epims-references/src/lib/states/+bankDetail/bank-detail.facade';
import { EpimsBankFacade } from './../../../../../epims-references/src/lib/states/+bank/bank.facade';

@Component({
  selector: 'mrsoftapps-budget-performance-container',
  templateUrl: './budget-performance-container.component.html',
  styleUrls: ['./budget-performance-container.component.scss'],
})
export class BudgetPerformanceContainerComponent implements OnInit {
  isLoadingProjectManagement$: Observable<any>;
  isLoadingCountry$: Observable<any>;
  isLoadingState$: Observable<any>;
  isLoadingLga$: Observable<any>;
  isLoadingProjectType$: Observable<any>;
  isLoadingProjectCategory$: Observable<any>;
  isLoadingCluster$: Observable<any>;
  isLoadingClusterCommunity$: Observable<any>;
  isLoadingCommunity$: Observable<any>;
  isLoadingOilBlock$: Observable<any>;
  isLoadingOilField$: Observable<any>;
  isLoadingDocumentCategory$: Observable<any>;
  isLoadingDocumentSubCategory$: Observable<any>;
  isLoadingCurrency$: Observable<any>;
  isLoadingGmou$: Observable<any>;
  isLoadingProjectPayment$: Observable<any>;
  isLoadingProjectStakeholder$: Observable<any>;
  isLoadingProjectCluster$: Observable<any>;
  isLoadingProjectDocument$: Observable<any>;
  isLoadingBankDetail$: Observable<any>;
  isLoadingBank$: Observable<any>;

  projectManagement$: Observable<ProjectDto[]>;
  searchProjectManagement$: Observable<ProjectDto[]>;
  country$: Observable<CountryDto[]>;
  state$: Observable<StateDto[]>;
  lga$: Observable<LgaDto[]>;
  projectType$: Observable<ProjectTypeDto[]>;
  projectCategory$: Observable<ProjectCategoryDto[]>;
  cluster$: Observable<ClusterDto[]>;
  clusterCommunity$: Observable<ClusterCommunityDto[]>;
  community$: Observable<CommunityDto[]>;
  oilBlock$: Observable<OilBlockDto[]>;
  oilField$: Observable<OilFieldDto[]>;
  documentCategory$: Observable<DocumentCategoryDto[]>;
  documentSubCategory$: Observable<DocumentSubCategoryDto[]>;
  currency$: Observable<CurrencyDto[]>;
  projectPayment$: Observable<ProjectPaymentDto[]>;
  projectStakeholder$: Observable<ProjectStakeholderDto[]>;
  projectCluster$: Observable<ProjectClusterDto[]>;
  projectDocument$: Observable<ProjectDocumentDto[]>;
  bankDetail$: Observable<EpimsBankDetailDto[]>;
  bank$: Observable<EpimsBankDto[]>;

  gmou$: Observable<GMOUDto[]>;
  projectData: ProjectDto;

  moitorProjectForm: FormGroup;
  bankDetails: any[];
  sub: Subscription;
  task = 'list';
  constructor(
    private projectManagementFacade: ProjectManagementFacade,
    private countryFacade: CountryFacade,
    private stateFacade: StateFacade,
    private lgaFacade: LgaFacade,
    private projectTypeFacade: ProjectTypeFacade,
    private projectCategoryFacade: ProjectCategoryFacade,
    private clusterFacade: ClusterFacade,
    private clusterCommunityFacade: ClusterCommunityFacade,
    private communityFacade: CommunityFacade,
    private oilBlockFacade: OilBlockFacade,
    private oilFieldFacade: OilFieldFacade,
    private documentCategoryFacade: DocumentCategoryFacade,
    private documentSubCategoryFacade: DocumentSubCategoryFacade,
    private gmouFacade: GmouFacade,
    private currencyFacade: CurrencyFacade,
    private projectPaymentFacade: ProjectPaymentFacade,
    private projectStakeholderFacade: ProjectStakeholderFacade,
    private projectClusterFacade: ProjectClusterFacade,
    private projectDocumentFacade: ProjectDocumentFacade,
    private bankDetailFacade: EpimsBankDetailFacade,
    private bankFacade: EpimsBankFacade,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.isLoadingProjectManagement$ = this.projectManagementFacade.isLoadingProjectManagement;
    this.isLoadingCountry$ = this.countryFacade.isLoadingCountry;
    this.isLoadingState$ = this.stateFacade.isLoadingState;
    this.isLoadingLga$ = this.lgaFacade.isLoadingLga;
    this.isLoadingCommunity$ = this.communityFacade.isLoadingCommunity;
    this.isLoadingOilBlock$ = this.oilBlockFacade.isLoadingOilBlock;
    this.isLoadingClusterCommunity$ = this.clusterCommunityFacade.isLoadingClusterCommunity;
    this.isLoadingCluster$ = this.clusterFacade.isLoadingCluster;
    this.isLoadingProjectType$ = this.projectTypeFacade.isLoadingProjectType;
    this.isLoadingProjectCategory$ = this.projectCategoryFacade.isLoadingProjectCategory;
    this.isLoadingOilField$ = this.oilFieldFacade.isLoadingOilField;
    this.isLoadingDocumentSubCategory$ = this.documentSubCategoryFacade.isLoadingDocumentSubCategory;
    this.isLoadingDocumentCategory$ = this.documentCategoryFacade.isLoadingDocumentCategory;
    this.isLoadingCurrency$ = this.currencyFacade.isLoadingCurrency;
    this.isLoadingGmou$ = this.gmouFacade.isLoadingGmou;
    this.isLoadingProjectPayment$ = this.projectPaymentFacade.isLoadingProjectPayment;
    this.isLoadingProjectStakeholder$ = this.projectStakeholderFacade.isLoadingProjectStakeholder;
    this.isLoadingProjectCluster$ = this.projectClusterFacade.isLoadingProjectCluster;
    this.isLoadingProjectDocument$ = this.projectDocumentFacade.isLoadingProjectDocument;
    this.isLoadingBank$ = this.bankFacade.isLoadingEpimsBank;

    this.country$ = this.countryFacade.loadCountry;
    this.state$ = this.stateFacade.loadState;
    this.lga$ = this.lgaFacade.loadLga;
    this.community$ = this.communityFacade.loadCommunity;
    this.oilBlock$ = this.oilBlockFacade.loadOilBlock;
    this.clusterCommunity$ = this.clusterCommunityFacade.loadClusterCommunity;
    this.projectType$ = this.projectTypeFacade.loadProjectType;
    this.cluster$ = this.clusterFacade.loadCluster;
    this.projectCategory$ = this.projectCategoryFacade.loadProjectCategory;
    this.oilField$ = this.oilFieldFacade.loadOilField;
    this.documentSubCategory$ = this.documentSubCategoryFacade.loadDocumentSubCategory;
    this.documentCategory$ = this.documentCategoryFacade.loadDocumentCategory;
    this.gmou$ = this.gmouFacade.loadGmou;
    this.currency$ = this.currencyFacade.loadCurrency;
    this.projectManagement$ = this.projectManagementFacade.loadProjectManagement;
    this.projectPayment$ = this.projectPaymentFacade.loadProjectPayment;
    this.projectCluster$ = this.projectClusterFacade.loadProjectCluster;
    this.projectStakeholder$ = this.projectStakeholderFacade.loadProjectStakeholder;
    this.projectDocument$ = this.projectDocumentFacade.loadProjectDocument;
    this.bank$ = this.bankFacade.loadEpimsBank;
    this.bankDetail$ = this.bankDetailFacade.getAllBankDetailById;
  }

  loadBeneficiary() {
    this.sub = this.bankDetail$.subscribe((data) => {
      this.bankDetails = data.map((item) => {
        return {
          BankName: item.BankName,
          SortCode: item.SortCode,
          BeneficiaryAccountName: item.BeneficiaryAccountName,
          BeneficiaryAccountNumber: item.BeneficiaryAccountNumber,
          Branch: item.Branch,
          Remark: item.Remark,
          BVN: item.BVN,
          StudentId: item.StudentId,
          id: item.id,
        };
      });
    });
  }

  onTriggerEmit(value) {
    this.projectManagementFacade.addProjectManagement(value);
  }

  onEmitActivity(value) {
    this.projectManagementFacade.addProjectSub(value);
  }

  onDeleteStakeholder(value) {
    this.projectStakeholderFacade.removeProjectStakeholder(value);
  }

  onSaveProjectCluster(value) {
    event.preventDefault();
    const pullData = value.MonitorProjectClusters;

    let allUpdates = [];
    let addAllCluster = [];

    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== undefined) {
        allUpdates.push(pullData[i]);
      } else {
        addAllCluster.push(pullData[i]);
      }
    }

    if (addAllCluster.length !== 0) {
      this.projectClusterFacade.addProjectCluster(addAllCluster);
    }
  }

  getBankDetail(id) {
    this.bankDetailFacade.loadEpimsBankDetail(id);
  }

  onSaveProjectPayment(value) {
    event.preventDefault();
    const pullData = value.MonitorProjectPayments;
    let allUpdates = [];
    let addAllPayment = [];

    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== undefined) {
        allUpdates.push(pullData[i]);
      } else {
        addAllPayment.push(pullData[i]);
      }
    }

    if (addAllPayment.length !== 0) {
      this.projectPaymentFacade.addProjectPayment(addAllPayment);
    }
  }

  onsaveProjectStakeholder(value) {
    event.preventDefault();
    const pullData = value.MonitorProjects;

    let allUpdates = [];
    let addAllStakelholder = [];

    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== undefined) {
        allUpdates.push(pullData[i]);
      } else {
        addAllStakelholder.push(pullData[i]);
      }
    }

    if (addAllStakelholder.length !== 0) {
      this.projectStakeholderFacade.addProjectStakeholder(addAllStakelholder);
    }
  }

  onsaveProjectCluster(value) {
    event.preventDefault();
    this.projectClusterFacade.addProjectCluster(value);
  }

  taskEvent(value) {}

  onDeleteEVent(value) {
    this.projectManagementFacade.removeProjectManagement(value);
  }

  onDeleteCluster(value) {
    this.projectClusterFacade.removeProjectCluster(value);
  }

  createBankDetail(formValue) {
    const pullData = formValue.BankDetails;

    // declare two empty array to hold update and create data
    let allUpdates = [];
    let addAllBankDetail = [];

    // loop through the form data to check for update and create

    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        addAllBankDetail.push(pullData[i]);
      }
    }

    // check if the addAllCountry array is not empty, then dispatch the data to the store
    if (addAllBankDetail.length !== 0) {
      this.bankDetailFacade.addEpimsBankDetail(addAllBankDetail);
    }

    // check if there is any update on the object
    const getChange = this.getChanges(this.bankDetails, allUpdates);

    // console.log('changed value ', getChange);
    if (getChange) {
      // dispatch update data to the store
      this.bankDetailFacade.updateEpimsBankDetail(allUpdates);
    }
  }

  deleteBankDetail(value) {
    this.bankDetailFacade.removeEpimsBankDetail(value);
  }

  getChanges(oldArray, newArray) {
    let changes, i, item, j, len;
    if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
      return false;
    }
    changes = [];
    for (i = j = 0, len = newArray.length; j < len; i = ++j) {
      item = newArray[i];
      if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
        changes.push(item);
      }
    }
    return changes;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
